import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import './EmptyUGCDisplay.scss';

export default class EmptyUGCDisplay extends React.PureComponent {
  render() {
    const { contentType } = this.props;

    return (
      <div className="cp-empty-ugc-display">
        <FormattedMessage id={`ugc_display_no_${contentType}`} />
      </div>
    );
  }
}

EmptyUGCDisplay.propTypes = {
  contentType: PropTypes.string
};
